/* tslint:disable:typedef-whitespace no-trailing-whitespace no-inferrable-types */

import { ElementRef         } from '@angular/core';

import { Dialog             } from './dialog';
import { Logger             } from '@/util/logger';
import { ServiceManager     } from "@/services/service.manager";
import { IValidatorCallBack } from './i.validator.call.back';
import { IOkCallBack        } from './i.ok.call.back';


/**
 *
 * @class CloneProjectDialog
 *
 * @brief dialog for picking (to clone) an existing project
 *
 * - - - - - - - - - - - - - - - - - - -
 * @author    Michael Garvin (mike.garvin@ironroad.ca)
 * @date      April 2020
 *
 */
export class CloneProjectDialog extends Dialog {

  /** standard constructor, allow for partial alert to be given */
  constructor(
    host: ElementRef,
    services: ServiceManager) {

    super(host);

    this.title = 'Clone Project';
    this.icon  = '<i class="fas fa-clone"></i>';

    Logger.debug('[CloneProjectDialog] setting up...');
  }

  /** dialog has been opened */
  public open(validator?: IValidatorCallBack, success?: IOkCallBack, options?: any) {

    Logger.debug('[CloneProjectDialog] opening...');




  }

  /** dialog is closing */
  public close() {

    Logger.debug('[CloneProjectDialog] closing...');
  }

  /** dialog was accepted */
  public ok() {

    Logger.debug('[CloneProjectDialog] accepted...');
  }
}


